module.exports = __webpack_public_path__ + "img/museum.7c56e222.jpg";